module.exports = __webpack_public_path__ + "static/media/emptyInfo.8875eda9.png";